<template>
  <div>
    <div class="text-left">
      <b-card title="Bitte legen Sie die Bestellung an:">
        <p>Das Anlegen der Bestellung dauert einen Moment. Bitte schließen Sie nicht das Fenster.</p>
        <b-button
            type="submit"
            variant="primary"
            @click="transferOrder"
            :disabled="orderSubmittingInProgress">
          <b-spinner v-if="orderSubmittingInProgress"  small label="Loading..."></b-spinner>
          Bestellung anlegen
        </b-button>
      </b-card>
    </div>
  </div>
</template>

<script>

import ProductSummary from "@/views/checkout/summary/ProductSummary";
import AddressSummary from "@/views/checkout/summary/AddressSummary";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, email, digits} from '@validations'

import {
  BCard,
  BCol,
  BRow,
  BForm,
  BButton, BSpinner,
} from "bootstrap-vue";
import {mapGetters} from "vuex";

export default {
  name: "CheckoutSummary",
  components: {
    AddressSummary,
    ProductSummary,
    BCard,
    BRow,
    BCol,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      load_order_summary: false,
      terms_and_conditions: false,
      privacy: false,
      order_summary_downloaded: false,
      order_summary_received: false,
      revocation: false,
      orderSubmittingInProgress: false,
      submitOrderHasAnError: false
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA', 'ORDER_STEPS_CURRENT', 'ORDER_STEPS_TOTAL', 'PRODUCT_ADDRESS', 'IS_EMPLOYEE', 'CAPTURE_METHOD']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    formatDate(datestring) {
      let date = new Date(datestring)

      return date.toLocaleDateString('de-DE')
    },
    hasPhonebookEntries() {
      let entries = this.CHECKOUT_DATA.phoneline.phonebook.filter(entry => entry.selected)

      return entries.length > 0
    },
    downloadSummary() {
      this.load_order_summary = true

      let data = {
        id: this.SERVICE.id,
        tenant: this.SERVICE.tenant,
        paperInvoice: this.CHECKOUT_DATA.invoice_paper,
        items: [],
        service: this.SERVICE,
        serviceOptions: this.CHECKOUT_DATA.serviceOptions,
        address: this.PRODUCT_ADDRESS
      }

      this.SERVICE.serviceItems.forEach(item => {
        data.items.push(item)
      })

      this.CHECKOUT_DATA.serviceOptions.forEach(item => {
        data.items.push(item.item)
      })

      this.$http.post('/order/summary', data).then(response => {
        let byteCharacters = atob(response.data.pdf);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let file = new Blob([byteArray], {type: 'application/pdf;base64'});
        let fileURL = URL.createObjectURL(file);
        window.open(fileURL);

        this.load_order_summary = false
        this.order_summary_downloaded = true
      })
    },
    submitOrder() {
      this.$refs.refFormObserver.validate()
          .then((success) => {
            this.validation = {}
            this.validate = false

            if (success) {
              this.transferOrder()
            }
          })
    },
    transferOrder() {
      this.CHECKOUT_DATA.serviceOptions = []
      this.CHECKOUT_DATA.serviceOptions = this.CHECKOUT_DATA.serviceOptions

      let services = [];

      this.CHECKOUT_DATA.additionalOptions.forEach((serviceOptionItem) => {
        if (serviceOptionItem.description === 'Zusätzlicher Sprachkanal' && this.CHECKOUT_DATA.countVoiceChannels > 1) {
          for (let i = 1; i <= this.CHECKOUT_DATA.countVoiceChannels; i++) {
            services.push(serviceOptionItem)
          }
        } else {
          services.push(serviceOptionItem)
        }
      })

      Object.keys(this.CHECKOUT_DATA.payTVOptions).forEach((key) => {
        services = services.concat(this.CHECKOUT_DATA.payTVOptions[key])
      })
      Object.keys(this.CHECKOUT_DATA.flatratesOptions).forEach((key) => {
        services = services.concat(this.CHECKOUT_DATA.flatratesOptions[key])
      })
      Object.keys(this.CHECKOUT_DATA.tvServiceOption).forEach((key) => {
        services = services.concat(this.CHECKOUT_DATA.tvServiceOption[key ])
      })

      this.CHECKOUT_DATA.serviceOptions = this.CHECKOUT_DATA.serviceOptions.concat(services);

      if (this.CHECKOUT_DATA.hardwareOptions.length !== 0) {
        this.CHECKOUT_DATA.serviceOptions.push(this.CHECKOUT_DATA.hardwareOptions)
      }

      this.orderSubmittingInProgress = true

      let data = {
        id: this.SERVICE.id,
        tenant: this.SERVICE.tenant,
        checkoutData: this.CHECKOUT_DATA,
        service: this.SERVICE,
        serviceOptions: this.CHECKOUT_DATA.serviceOptions,
        address: this.PRODUCT_ADDRESS,
        isemployee: this.IS_EMPLOYEE,
        capture_method: this.CAPTURE_METHOD,
      }

      if (this.CHECKOUT_DATA.appointment == 2) {
        data.appointment_date = this.CHECKOUT_DATA.appointment_date
      }

      this.$http.post('/orders', data).then(response => {
        this.orderSubmittingInProgress = false

        if (response.data.error) {
          this.submitOrderHasAnError = true
        } else {
          this.$router.push(
              {
                name: 'orders-view',
                params: {id: response.data.order.id}
              },
              () => setTimeout(() => {
                this.$bvToast.toast(('Bestellung erstellt.'), {
                  title: ('Erfolgreich'),
                  variant: 'success',
                  toaster: 'b-toaster-bottom-right'
                })
              })
          )
        }
      })
    },
  },
  mounted() {
    if (this.IS_EMPLOYEE) {
      this.terms_and_conditions = true
      this.privacy = true
      this.revocation = true
    }
  },
  beforeMount() {
    if (!this.SERVICE || !this.CHECKOUT_DATA) {
      this.$router.push({name: 'orders-add'})
    }

    this.$store.commit('SET_ORDER_STEPS_CURRENT', 3)
  }
}
</script>

<style scoped>

</style>
